// Push Notifications Adapters — Firebase FCM
// Transform API responses to UI-friendly formats

import type {Campaign, CampaignListItem, DashboardStats, PaginatedCampaigns} from "@/types/push.types";

// API responses already come in camelCase format, so adapters are minimal
// These exist for consistency and future-proofing

export const toCampaign = (raw: Campaign): Campaign => raw;

export const toCampaignListItem = (raw: CampaignListItem): CampaignListItem => raw;

export const toPaginatedCampaigns = (raw: PaginatedCampaigns): PaginatedCampaigns => ({
  data: raw.data.map(toCampaignListItem),
  pagination: raw.pagination,
});

export const toDashboardStats = (raw: DashboardStats): DashboardStats => ({
  ...raw,
  recentCampaigns: raw.recentCampaigns || [],
});

// Helper to format campaign status for UI display
export const getCampaignStatusColor = (status: Campaign["status"]): "gray" | "blue" | "amber" | "green" | "red" => {
  const statusColors: Record<Campaign["status"], "gray" | "blue" | "amber" | "green" | "red"> = {
    draft: "gray",
    scheduled: "blue",
    sending: "amber",
    sent: "green",
    failed: "red",
    cancelled: "gray",
  };
  return statusColors[status];
};

// Helper to format category for UI display
export const getCampaignCategoryColor = (
  category: Campaign["category"]
): "gray" | "blue" | "amber" | "green" | "red" | "purple" => {
  const categoryColors: Record<Campaign["category"], "gray" | "blue" | "amber" | "green" | "red" | "purple"> = {
    general: "gray",
    transactional: "blue",
    marketing: "purple",
    kyc: "amber",
    security: "red",
    promotion: "green",
  };
  return categoryColors[category];
};

// Helper: Format percentage with 1 decimal
export const formatPercentage = (value?: number | null): string => {
  if (value === undefined || value === null) return "0.0%";
  return `${value.toFixed(1)}%`;
};

// Helper: Format large numbers with commas
export const formatNumber = (value?: number | null): string => {
  if (value === undefined || value === null) return "0";
  return new Intl.NumberFormat("en-US").format(value);
};
